import { render, staticRenderFns } from "./AddRegistrantModal.vue?vue&type=template&id=03c94748&scoped=true"
import script from "./AddRegistrantModal.vue?vue&type=script&lang=js"
export * from "./AddRegistrantModal.vue?vue&type=script&lang=js"
import style0 from "./AddRegistrantModal.vue?vue&type=style&index=0&id=03c94748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c94748",
  null
  
)

export default component.exports